import { createSlice } from "@reduxjs/toolkit";
import { LOAD_ALL_SITE, LOAD_SINGLE_SITE } from "./SiteList.saga";

export const siteListSlice = createSlice({
  name: "siteList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedSite: null,
    filteredRecords: 0,
    isSingleSiteLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
    isSingleSiteNotFound: false,
  },
  reducers: {
    setAllSiteLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleSiteLoadingState: (state, action) => {
      state.isSingleSiteLoading = true;
      state.isSingleSiteNotFound = false;
      state.selectedSite = null;
    },
    loadAllSite: (state, action) => {
      const listObj = {};
      action.payload.sites.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.sites.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleSite: (state, action) => {
      state.selectedSite =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleSiteLoading = false;
      state.isSingleSiteNotFound = false;
    },
    addSingleSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    setSingleSiteNotFound: (state, action) => {
      state.isSingleSiteNotFound = action.payload;
    },
  },
});

export const {
  setAllSiteLoadingState,
  setSingleSiteLoadingState,
  loadAllSite,
  loadSingleSite,
  addSingleSite,
  setSingleSiteNotFound,
} = siteListSlice.actions;

export default siteListSlice.reducer;
